var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"13.5","cy":"10.821","r":"6.25","fill":"#FCCE44"}}),_c('circle',{attrs:{"cx":"7.25","cy":"7.25","r":"6.696","fill":"#FCCE44","stroke":"#fff","stroke-width":".893"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }